import React from 'react';
import './ProfilePicture.css'

const ProfilePicture = () => (
  <div className="profilePicture">
    <img src="images/perfil_nerd.jpg" alt="MyProfilePicture"/>
  </div>
);

export default ProfilePicture;
